export const HiringManagerIcon = ({ primaryColor = "#ffd800", primaryFontColor = "#3b4046" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="113.888"
      height="113.929"
      viewBox="0 0 113.888 113.929"
    >
      <defs>
        <filter
          id="Path_6202"
          x="0"
          y="0"
          width="113.888"
          height="113.929"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood flood-opacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_43393" data-name="Group 43393" transform="translate(9 6)">
        <path
          d="M102.97,73.07
       a95.86,95.86,0,0,0,0-38.2
       a31.8,31.8,0,0,0-26.29-26.81
       a95.85,95.85,0,0,0-39.44,0
       a31.8,31.8,0,0,0-26.18,26.14
       a95.84,95.84,0,0,0,0,39.54
       a31.8,31.8,0,0,0,25.96,26.1
       a95.85,95.85,0,0,0,39.88,0
       a31.8,31.8,0,0,0,26.07-26.87
       Z"
          fill={primaryColor}
          filter="url(#shadow)"
        />
        <g
          id="Group_1933"
          data-name="Group 1933"
          transform="translate(36.988 28.555)"
        >
          <path
            id="Path_6203"
            data-name="Path 6203"
            d="M3257.7,804.769a12.3,12.3,0,1,0-12.3-12.3A12.318,12.318,0,0,0,3257.7,804.769Z"
            transform="translate(-3236.742 -780.161)"
            fill={primaryFontColor}
          />
          <path
            id="Path_6204"
            data-name="Path 6204"
            d="M3248.181,900.7a17.676,17.676,0,0,0-8.024-6.351,4.782,4.782,0,0,0-4.226.165,15.3,15.3,0,0,1-6.644,1.677h-.131a15.267,15.267,0,0,1-6.653-1.677,4.8,4.8,0,0,0-4.232-.165,17.622,17.622,0,0,0-8.018,6.35,12.177,12.177,0,0,0-1.984,5.925,4.824,4.824,0,0,0,1.534,3.825c5.756,5.392,15.839,5.794,18.71,5.794.311,0,.537,0,.664-.008l.283,0c2.085.028,13.041-.055,19.171-5.787a4.867,4.867,0,0,0,1.535-3.823h0A12.189,12.189,0,0,0,3248.181,900.7Z"
            transform="translate(-3208.26 -867.425)"
            fill={primaryFontColor}
          />
        </g>
      </g>
    </svg>
  );
};
